import logo from '../logo.svg';

const strings = {
    home: {
        header: 'I am <place name here>'
    }
}

const images = {
    home: {
        logo
    }
}

const config = {
    strings,
    images
}

export { config };